<template>
  <div class="modelcover" @click="handleCloseReset">
    <div class="sigin" @click.stop="">
    		<div class="modal">
    			<div class="title">
    				重置密码
    			</div>
    			<div class="flex list" style="margin-top: 50px;">
    				<img src="../assets/img/usericon.png" width="19" height="20">
    				<input type="tel" name="" id="" value="" placeholder="请输入手机号" v-model="phone" />
    			</div>
    			<div class="flex list">
    				<img src="../assets/img/codeicon.png" width="19" height="20" >
    				<input type="tel" name="" id="" value="" placeholder="请输入短信验证码" class="flex1" v-model="code" />
    				<span style="color: #4fa7ff;cursor: pointer;" v-if="canget" @click="handleGetCode()">获取验证码</span>
    				<span style="color: #4fa7ff;cursor: pointer;" v-else>{{seconds}}s</span>
    			</div>
    			<div class="flex list">
    				<img src="../assets/img/passwordicon.png" width="18" height="20" >
    				<input type="password" name="" id="" value="" placeholder="请输入密码" v-model="password" />
    			</div>
    	<!-- 		<div class="flex" style="margin-top: 30px;align-items: center;">
    				<input type="checkbox" name="" id="" value="" />
    				<span style="color: #999;margin-left: 5px;">阅读并同意</span><span style="color: #4fa7ff;">《用户协议》</span>
    				<span style="color: #4fa7ff;">《隐私政策》</span>
    			</div> -->
    			<div class="btn" style="cursor: pointer;" @click="handleReset">
    				登录
    			</div>
    		</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
          showLogin:false,
          phone:'',
          uuid:'',
          code:'',
          password:'',
          seconds:60,
          canget:true
      }
    },
    methods:{
      handleCloseReset(){

        this.$emit('handleCloseReset')
      },
      handleGetCode(){
        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('templateType',1);
        this.$axios.post(this.$common.sendSMS_url,data).then((res)=>{
              if(res.data.code==1){
                  this.canget=false;
                  this.uuid=res.data.data;
                  timer=setInterval(()=>{
                    if(this.seconds==0){
                      clearInterval(timer);
                      this.canget=true;
                      this.seconds=60
                    }
                    else {
                      this.seconds--;
                    }
                  },1000)

              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleReset(){
        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        if(this.password.length<6){
          alert('登录密码不能少于6位');

          return ;
        }
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('code',this.code);
            data.append('uuid',this.uuid);
            data.append('password',this.password);
            data.append('againPassword',this.password);
        this.$axios.post(this.$common.resetPwd_url,data).then((res)=>{
              if(res.data.code==1){
                alert(res.data.msg)
                this.$emit('reseted')
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    }
  }
</script>

<style scoped>
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
        z-index: 1988;
  }
  .sigin {
  	width: 390px;
  	    height: 435px;
  	    border-radius: 10px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
  }
  .sigin .title {
  	font-size: 24px;
  }
  .sigin input {
  	border: none;
  	line-height: 40px;
  	outline: none;
  	text-indent: 15px;
  	font-size: 16px;
  }
  .sigin .list {
  	border-bottom: 1px solid #eee;
  	align-items: center;
  	margin-top: 25px;
  }
  .sigin .btn {
  	height: 50px;
  	text-align: center;
  	line-height: 50px;
  	color: #fff;
  	background-color: #4fa7ff;
  	border-radius: 4px;
  	margin-top: 70px;
  	font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reset.vue